import { apiService } from '../../../shared/services/apiService';
import { apiStatusStore } from '../../../shared/stores/apiStatusStore';
import { AddPromoCodeRequest, PromoCodeInfo } from '../../interfaces/promoCodeInfo';
import { PromoCodesService } from './promoCodesService';

export const challengePromoCodeService: PromoCodesService = {
  async getPromoCodes(challengeId: number) {
    const response = await apiService.get<PromoCodeInfo[]>(
      `/api/challenges/${challengeId}/promocodes`,
    );

    return response.data;
  },

  // Unavailable APIs - throw Error and show message
  // Challenge doesn't have subscriptions
  async getSubscriptions() {
    const errorMessage = `Promo codes subscriptions are not available for Challenge`;
    apiStatusStore.addErrorMessage(errorMessage);
    throw new Error(errorMessage);
  },

  async addPromoCode(
    challengeId: number,
    promoCodeRequest: AddPromoCodeRequest,
    isRunGlobalSpinner = false,
  ) {
    const response = await apiService.post<PromoCodeInfo>(
      `/api/challenges/${challengeId}/promocode`,
      promoCodeRequest,
      { isRunGlobalSpinner },
    );

    return response.data;
  },

  async togglePromoCode(challengeId: number, promoCodeId: number, pause: boolean) {
    const response = await apiService.put<PromoCodeInfo>(
      `/api/challenges/${challengeId}/promocode/${promoCodeId}/pause`,
      undefined,
      { params: { pause } },
    );

    return response.data;
  },
};
